
import $ from "jquery";
window.$ = $;
export default {  
  init() {   
    $('#filter').submit(function () {
      var filter = $('#filter');
      $.ajax({
        url: filter.attr('action'),
        data: filter.serialize(), 
        type: filter.attr('method'),
        success: function (data) {
          $('#response').html(data); 
        }
      });
      return false;
    });
  },
  finalize() {},
};
